/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_SponsorshipInputs */

const en_common_header_sponsorship = /** @type {(inputs: Common_Header_SponsorshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsorship`)
};

const zh_common_header_sponsorship = /** @type {(inputs: Common_Header_SponsorshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赞助`)
};

/**
* | output |
* | --- |
* | "Sponsorship" |
*
* @param {Common_Header_SponsorshipInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_sponsorship = /** @type {((inputs?: Common_Header_SponsorshipInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_SponsorshipInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_sponsorship(inputs)
	return zh_common_header_sponsorship(inputs)
});
export { common_header_sponsorship as "common.header.sponsorship" }